var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.content)?_c('div',{ref:"noteTextContent",class:{
      clampFourLines: !_vm.noteIsExpanded,
      campText: true,
      'mt-1': true
    }},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]):_vm._e(),(_vm.content && _vm.isOverflowing)?_c('button',{on:{"click":_vm.toggleText}},[_c('b',[_vm._v(" "+_vm._s(_vm.noteIsExpanded ? "Show Less" : "Show More"))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }